export type AppLanguage = "en" | "de";
export type AppLanguageFilter = AppLanguage | "all";

export type AppLanguageOption<TValue extends string> = {
  label: string;
  value: TValue;
};

export const APP_LANGUAGES: readonly AppLanguage[] = ["en", "de"];

export const APP_LANGUAGE_OPTIONS: AppLanguageOption<AppLanguage>[] = [
  { label: "🇬🇧 English", value: "en" },
  { label: "🇩🇪 German", value: "de" },
];

export const APP_LANGUAGE_FILTER_OPTIONS: AppLanguageOption<AppLanguageFilter>[] =
  [{ label: "🌐 All Languages", value: "all" }, ...APP_LANGUAGE_OPTIONS];
